import { render, staticRenderFns } from "./amazonadproducts.vue?vue&type=template&id=2b0aab79"
import script from "./amazonadproducts.vue?vue&type=script&lang=js"
export * from "./amazonadproducts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports